import React from 'react';
import { inject, observer } from 'mobx-react';
import H5ActivityList from './h5';
import PCActivityList from './pc';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import { withRouter, RouteComponentProps } from 'react-router-dom';

interface ActivityListProps extends RouteComponentProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    data?: any;
    loading?: boolean;
    hasMore?: boolean;
    onLoadMore?: () => void;
    emptyText?: string; // 为空时提示文字
    emptyIcon?: string; // 为空时icon
    emptyBoxStyle?: any; // 为空状态时的自定义样式
    isLeftSize?: any;   // 是否显示在左侧内容区域，如果是，需要列表内容宽度小一点，适配左边878px的宽度（pc）
    searchKeyword?: any
}

@inject('app', 'site', 'user')
@observer
class ActivityList extends React.Component<ActivityListProps> {
    componentDidMount() {
        // 可以在这里添加初始化逻辑
        // console.log('组件组件');
    }

    render() {
        const { site, app, data, isLeftSize, searchKeyword,loading, hasMore, onLoadMore, ...props } = this.props;
        const platform = app?.platform || 'h5';
         // 确保传递 data 属性，即使为空数组
        const postListData = data || [];
        // console.log(postListData, platform, '组件入口')
        if (platform === 'pc') {
            return <PCActivityList {...props} isLeftSize={isLeftSize} searchKeyword={searchKeyword} data={postListData} loading={loading}
            hasMore={hasMore}
            onLoadMore={onLoadMore || (() => { })}/>;
        } else {
            return <H5ActivityList {...props} data={postListData} searchKeyword={searchKeyword}loading={loading}
            hasMore={hasMore}
            onLoadMore={onLoadMore || (() => { })} />;
        }
    }
}

export default withRouter(ActivityList);